import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const TestimonialCard = ({ name, role, business, content, rating, image }) => {
  return (
    <motion.div
      className="card p-8 h-full flex flex-direction flex-col border border-gray-200 relative overflow-hidden hover:-translate-y-1"
      whileHover={{ y: -4 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary-500 to-secondary-500"></div>
      
      <div className="mb-6">
        <div className="flex gap-1">
          {[...Array(rating)].map((_, index) => (
            <Star key={index} className="w-4 h-4 text-yellow-400 fill-current" />
          ))}
        </div>
      </div>
      
      <blockquote className="text-gray-700 leading-relaxed mb-8 flex-1 relative italic">
        <span className="absolute -top-2 -left-2 text-4xl text-primary-500 opacity-30 font-serif leading-none">"</span>
        {content}
      </blockquote>
      
      <div className="flex items-center gap-4 mt-auto">
        <img 
          src={image} 
          alt={name}
          className="w-12 h-12 rounded-full object-cover border-2 border-gray-200"
        />
        <div className="flex-1">
          <div className="font-semibold text-gray-900 mb-1">{name}</div>
          <div className="text-sm text-primary-500 font-medium mb-0.5">{role}</div>
          <div className="text-xs text-gray-500">{business}</div>
        </div>
      </div>
    </motion.div>
  );
};

export default TestimonialCard;
